import { Hero } from "@/sections/Hero";
import { ClientStrip } from "@/sections/ClientStrip";
import { Statement } from "@/sections/Statement";
import { Services } from "@/sections/Services";
import { Work } from "@/sections/Work";
import { Marquee } from "@/sections/Marquee";
import { WhyNovo } from "@/sections/WhyNovo";
import { TemplateShowcase } from "@/sections/TemplateShowcase";
import { Process } from "@/sections/Process";
import { AlwaysOn } from "@/sections/AlwaysOn";
import { FinalCTA } from "@/sections/FinalCTA";

export default function Home() {
  return (
    <main>
      <Hero />
      <ClientStrip />
      <Statement />
      <Services />
      <Work preview />
      <Marquee />
      <WhyNovo compact />
      <TemplateShowcase />
      <Process />
      <AlwaysOn />
      <FinalCTA />
    </main>
  );
}
